import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot } from '@angular/router';

import { NavigationConfigService } from '@app/services/navigation-config/navigation-config.service';

export const navigationResolver = (route: ActivatedRouteSnapshot): void => {
  const navigationService: NavigationConfigService = inject(NavigationConfigService);

  return navigationService.updateSelectedTab(route.url[0].path);
};
